import { Controller } from "@hotwired/stimulus"

// Scenes tab controller — keyboard navigation between scene cards
export default class extends Controller {
  static targets = ["list"]

  connect() {
    this.selectedIndex = 0
    this.bindKeyboard()
  }

  disconnect() {
    this.unbindKeyboard()
  }

  bindKeyboard() {
    this.keydownHandler = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.keydownHandler)
  }

  unbindKeyboard() {
    if (this.keydownHandler) {
      document.removeEventListener("keydown", this.keydownHandler)
    }
  }

  handleKeydown(event) {
    if (event.target.matches("input, textarea, select")) return

    const cards = this.getCards()
    if (!cards.length) return

    switch (event.key) {
      case "j":
      case "ArrowDown":
        event.preventDefault()
        this.selectedIndex = Math.min(this.selectedIndex + 1, cards.length - 1)
        cards[this.selectedIndex]?.scrollIntoView({ behavior: "smooth", block: "nearest" })
        break
      case "k":
      case "ArrowUp":
        event.preventDefault()
        this.selectedIndex = Math.max(this.selectedIndex - 1, 0)
        cards[this.selectedIndex]?.scrollIntoView({ behavior: "smooth", block: "nearest" })
        break
    }
  }

  getCards() {
    if (!this.hasListTarget) return []
    return Array.from(this.listTarget.querySelectorAll("[data-sortable-id]"))
  }
}
